class PrivateSaleQuickbuyModalForm extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.formEl = this.els.form.element
    this.inputEl = this.els.input.element
    this.successEl = this.els.success.element
    this.errorEl = this.els.error.element

    this.handleSubmit = this.handleSubmit.bind(this)
    this.grantAccess = this.grantAccess.bind(this)
    this.showSuccess = this.showSuccess.bind(this)
    this.showError = this.showError.bind(this)
    this.clearError = this.clearError.bind(this)
  }

  static get requiredElements () {
    return ['form', 'input', 'success', 'error']
  }

  setupListeners () {
    this.listeners.add(this.formEl, 'submit', this.handleSubmit)
    this.listeners.add(this.inputEl, 'input', this.clearError)
  }

  handleSubmit (evt) {
    evt.preventDefault()

    const saleType = this.formEl.dataset.saleType

    if (saleType === 'email') {
      this.handleEmailPromo()
    } else if (saleType === 'passcode') {
      this.handleCodePromo()
    }
  }

  handleEmailPromo () {
    if (!this.inputEl.validity.valid) {
      this.showError(this.genericError)
      return
    }

    this.setAttribute('aria-busy', true)

    this.newsletterSubscribe(this.inputEl.value, this.formEl)
  }

  async newsletterSubscribe () {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.inputEl.value,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.config.listId,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: '2023-12-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoApiKey}`,
        options,
      )

      if (response.status === 202) {
        window.BAO.Utils.setCookie(`isRegistered`, true, 31)
        this.showSuccess()
      } else {
        const error = response.error || this.genericError
        this.showError(error)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    } finally {
      this.removeAttribute('aria-busy')
    }
  }

  handleCodePromo () {
    if (!this.inputEl || this.inputEl.value !== this.passcode) {
      this.showError(this.genericError)
      return
    }

    this.setAttribute('aria-busy', true)
    this.showSuccess()
    this.setAttribute('aria-busy', false)
  }

  grantAccess () {
    document.body.classList.remove(this.config.bodyClass)
    this.setCartAttribute()
    window.dispatchEvent(new CustomEvent('unlockPrivateSale'))
  }

  async setCartAttribute () {
    const res = await fetch(`${window.routes.cart_url}.js`)
    const { attributes } = await res.json()

    const newAttributes = {
      ...attributes,
      [this.cartAttributeKey]: true,
    }

    try {
      fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: newAttributes }),
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  showSuccess () {
    this.successEl.removeAttribute('aria-hidden')
    this.formEl.setAttribute('aria-hidden', true)
    window.setTimeout(this.grantAccess, 2000)
  }

  showError (message) {
    this.errorEl.innerText = message
    this.errorEl?.setAttribute('aria-hidden', false)
  }

  clearError () {
    this.errorEl.innerText = ''
    this.errorEl.setAttribute('aria-hidden', true)
  }

  get klaviyoApiKey () {
    return window.theme.klaviyo.apiKey
  }

  get config () {
    const rawData = window.atob(this.formEl.dataset.config)
    return JSON.parse(rawData)
  }

  get cartAttributeKey () {
    return window.atob(this.formEl.dataset.attributeKey)
  }

  get passcode () {
    return window.atob(this.formEl.dataset.pc)
  }

  get genericError () {
    return this.formEl.dataset.genericError
  }
}

customElements.define(
  'private-sale-quickbuy-modal-form',
  PrivateSaleQuickbuyModalForm,
)
